import { Typography, Box } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';

export default function AvisoPrivacidad() {
  return (
    <>
      <SEO
        title="Aviso de Privacidad | Rolsys Solutions"
        description="Aviso de privacidad de Rolsys Solutions. Conoce cómo protegemos y utilizamos tus datos personales."
      />

      <Box>
        <Typography variant="h3" sx={{ mb: 3, fontWeight: 800 }}>
          Aviso de Privacidad
        </Typography>

        {/*ESTE ES EL PRIMER PARRAFO DEL AVISO */}

        <Typography paragraph>
          Para cumplir con la{' '}
          <strong>
            Ley Federal de Protección de Datos Personales en Posesión de los
            Particulares (LFPDPPP)
          </strong>{' '}
          y satisfacer la revisión sin exponerte de más, aquí tienes una
          estructura profesional y discreta.
        </Typography>
        {/*ESTE ES EL TITULO DEL SEGUNDO PARRAFO */}
        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Responsable de la protección de sus datos personales
        </Typography>
        {/*ESTE ES EL TEXTO DEL SUBTITULO ANTERIOR */}
        <Typography paragraph>
          El responsable del tratamiento de sus datos personales es{' '}
          <strong>Edoardo Ernesto Maciel Roldán</strong>, operando
          comercialmente como <strong>Rolsys Solutions</strong>, con domicilio
          para oír y recibir notificaciones en la Ciudad de México. Usted puede
          contactarnos a través del correo electrónico:{' '}
          <strong>contacto@rolsyssolutions.com</strong>.
        </Typography>
        {/*ESTE ES EL TITULO DEL TERCER PARRAFO */}
        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Finalidad del tratamiento
        </Typography>
        {/*ESTE ES EL TEXTO DEL TERCER TITULO */}
        <Typography paragraph>
          Los datos personales que recabamos serán utilizados para las
          siguientes finalidades necesarias para el servicio:
          <ul>
            <li>
              Proveer los servicios de soporte técnico en Tecnologías de la
              Información solicitados.
            </li>
            <li>
              Gestión de soluciones de software empresarial y consultoría técnica para la optimización de la infraestructura digital del cliente.
            </li>
            <li>
              Proceso de facturación y cobranza por la venta de equipos
              reacondicionados.
            </li>
            <li>
              Atención a clientes a través de canales oficiales como WhatsApp
              Business.
            </li>
          </ul>
          <strong>Datos personales recabados:</strong> Para llevar a cabo las
          finalidades descritas, utilizaremos datos de identificación y contacto
          proporcionados directamente por el titular. No recabamos datos
          personales sensibles.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Derechos ARCO
        </Typography>
        <Typography paragraph>
          Usted tiene derecho a conocer qué datos personales tenemos de usted
          (Acceso), solicitar su corrección (Rectificación), que los eliminemos
          de nuestros registros (Cancelación) u oponerse al uso de los mismos
          para fines específicos (Oposición). Para ejercer estos derechos, envíe
          una solicitud al correo mencionado anteriormente.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Derechos de Marca de Terceros (Afiliados)
        </Typography>
        <Typography paragraph>
          En diversas secciones de este sitio web hacemos mención a marcas, nombres comerciales y logotipos de terceros (tales como Hostinger). Todas las marcas registradas, logotipos y nombres comerciales mencionados son propiedad exclusiva de sus respectivos dueños (p. ej., Hostinger International, Ltd.). Su uso en este sitio tiene fines puramente informativos o promocionales bajo programas de afiliación, y no implica propiedad directa por parte de Rolsys Solutions.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
          Venta y Transferencia de Dominios Web
        </Typography>
        <Typography paragraph>
          Rolsys Solutions actúa como propietario legítimo de los dominios ofertados en la sección correspondiente. La forma de entrega dependerá de cada caso particular. En caso de compra directa, se procederá a la actualización de los datos del propietario; sin embargo, el dominio se mantendrá gestionado dentro de la cuenta de Rolsys Solutions, ofreciendo servicios de hosting incluidos por 1 año. Si el cliente solicita la transferencia del dominio, este deberá adquirir los servicios con un proveedor de su elección. Rolsys Solutions facilitará el código de autorización (EPP) correspondiente y, a partir de ese momento, no se hará responsable por la gestión, operatividad o cualquier incidencia derivada con el nuevo proveedor.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
          Última actualización: Enero 2026
        </Typography>
      </Box>
    </>
  );
}
